import onSearchTextChange from './action-auto-complete';
import getHelpCenterAlerts from './actions-helpcenter-alerts';

export default {
  onSearchTextChange,
  getHelpCenterAlerts,
};
